import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';

// Copies `text` to the clipboard and shows the result for a moment. Used by code blocks and tool chips.
export default function CopyButton({ text, label = 'Copy', className = 'cc-md-copy' }) {
  const [state, setState] = useState(''); // '' | 'copied' | 'failed'
  const copy = async (e) => {
    e.stopPropagation();
    try {
      if (navigator.clipboard && window.isSecureContext !== false) await navigator.clipboard.writeText(text);
      else throw new Error('no clipboard');
      setState('copied');
    } catch {
      setState('failed');
    }
    setTimeout(() => setState(''), 1600);
  };
  return (
    <button type="button" className={className} onClick={copy} aria-label={`${label} to clipboard`}>
      {state === 'copied' ? <Check size={14} /> : <Copy size={14} />}
      {state === 'copied' ? 'Copied' : state === 'failed' ? 'Copy failed' : label}
    </button>
  );
}
